module.exports = __webpack_public_path__ + "img/authComIcon.ab040926.png";